import { COMPANIES_FETCHED} from "../actions/companies";

export default (state = null, action = {}) => {
  switch (action.type) {
    case COMPANIES_FETCHED:
      return action.payload;
    default:
      return state;
  }
};
